import React from 'react'
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_helpers";

export function Settings() {
  return (
    <>
      <div className="topbar-item">
        <div
          className="btn btn-icon btn-clean btn-lg mr-2"
          id="kt_quick_notifications_toggle"
        >
          <span className="svg-icon svg-icon-xl svg-icon-primary">
            <Link to="/hookapi">
              <img
                alt=""
                src={toAbsoluteUrl(
                  "/media/sr/icons/Page Settings header Active.svg"
                )}
              />
            </Link>{" "}
          </span>
        </div>
      </div>
    </>
  );
}
